export const year2024 = [
  { year: 2024 },
  {
    name: "Secure Web Application Development",
    author: "Kobalt.io",
    type: "Training",
    link: "https://kobalt.io/security-web-app-development-course/",
  },
  {
    name: "Intermediate React Native v2",
    author: "Kadi Kraman",
    type: "Course",
    link: "https://frontendmasters.com/courses/intermediate-react-native-v2/",
    repo: "https://github.com/andreidobrinski/intermediate-react-native-v2-fm-course",
  },
  {
    name: "React Native v3",
    author: "Kadi Kraman",
    type: "Course",
    link: "https://frontendmasters.com/courses/react-native-v3/",
    repo: "https://github.com/andreidobrinski/react-native-v3-fm-course",
  },
  {
    name: "Guide for Launching Your Next Big Idea",
    author: "Paul Boag",
    type: "Course",
    link: "https://frontendmasters.com/courses/product-launch/",
    repo: "https://github.com/andreidobrinski/guide-for-launching-your-next-big-idea-fm-course",
  },
  {
    name: "A Tour of Web Capabilities",
    author: "Maximiliano Firtman",
    type: "Course",
    link: "https://frontendmasters.com/courses/device-web-apis/",
    repo: "https://github.com/andreidobrinski/a-tour-of-web-capabilities-fm-course",
  },
];
